<template>
	<v-card flat outlined>
		<v-container fluid class="pb-0">
			<v-row>
				<v-col cols="12" lg="12" class="pb-0 pt-0">
					<v-card flat class="pb-0 pt-0">
						<v-card-text class="pb-0">
							<v-row class="d-flex justify-space-between">
								<v-col class="d-flex justify-start pb-0 pt-0">
									<div :class="['subtitle-1', 'pa-0']">
										{{ $t('labels.totalExperience') }}
										<b>{{ totalDuration.toFixed(2) }} </b>
										{{ $t('labels.months') }}
									</div>
								</v-col>
								<v-col class="d-flex justify-center pb-0 pt-0">
									<v-card-title class="pa-0"> {{ $t('titles.teacherNavigations') }}</v-card-title>
								</v-col>
								<v-col class="d-flex justify-end pa-0 pl-2">
									<v-btn color="primary" @click="addClick">
										<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.addNavigation') }}
									</v-btn>
								</v-col>
							</v-row>
							<v-row>
								<v-col class="pt-0 pb-0">
									<TheTable
										:additional-filters="teacherNavigationsTable.additionalFilters"
										:default-sort="teacherNavigationsTable.defaultSort"
										:excel="false"
										:fields="teacherNavigationsTable.headers"
										:header-selection-key="'teacher-navigations-headers'"
										:height="teacherNavigationsTable.height"
										:total-records="teacherNavigationsTable.total"
										:filter-save-key="'teacher-navigations-filters'"
										@headers="selectHeaders"
										@reload="reloadData"
									>
										<tr
											v-for="(item, key) in teacherNavigationsTable.items"
											:key="key"
											:class="{ 'cursor-pointer': true }"
											@contextmenu.prevent="editClick(item.id)"
										>
											<td
												v-if="teacherNavigationsTable.selectedHeaders.includes('company')"
												@click="editClick(item.id)"
											>
												{{ item.company }}
											</td>
											<td
												v-if="teacherNavigationsTable.selectedHeaders.includes('rank_id')"
												@click="editClick(item.id)"
											>
												{{ item.rank.name }}
											</td>
											<td
												v-if="teacherNavigationsTable.selectedHeaders.includes('ship_type')"
												@click="editClick(item.id)"
											>
												{{ item.ship_type }}
											</td>
											<td
												v-if="teacherNavigationsTable.selectedHeaders.includes('start_date')"
												@click="editClick(item.id)"
											>
												{{
													item.start_date != null
														? item.start_date.split('-').reverse().join('.')
														: ''
												}}
											</td>
											<td
												v-if="teacherNavigationsTable.selectedHeaders.includes('end_date')"
												@click="editClick(item.id)"
											>
												{{
													item.end_date != null
														? item.end_date.split('-').reverse().join('.')
														: ''
												}}
											</td>
											<td
												v-if="teacherNavigationsTable.selectedHeaders.includes('duration')"
												@click="editClick(item.id)"
											>
												{{ item.duration.toFixed(2) }}
											</td>
											<td>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn
															icon
															small
															v-bind="attrs"
															@click="deleteClick(item.id)"
															v-on="on"
														>
															<v-icon small>fas fa-trash</v-icon>
														</v-btn>
													</template>
													<span>{{ $t('tooltips.deleteNavigation') }}</span>
												</v-tooltip>
											</td>
										</tr>
									</TheTable>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
			<v-col>
				<Modal :show-modal="showModal">
					<Navigation
						:navigationId="selectedNavigation"
						:inEditMode="true"
						@close="closeModal"
						@reloadData="reloadData(teacherNavigationsTable.lastRequest)"
					></Navigation>
				</Modal>
			</v-col>
		</v-container>
	</v-card>
</template>

<script>
import TheTable from '../../trinkets/TheTable';
import Modal from '../../trinkets/Modal';
import Navigation from './Navigation';

export default {
	name: 'TeacherNavigations',
	components: { TheTable, Modal, Navigation },
	data: function () {
		return {
			teacherNavigationsTable: {
				selectedHeaders: [],
				headers: [
					{
						text: this.$t('fields.companyName'),
						value: 'company',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{ text: this.$t('fields.rank'), value: 'rank_id', type: '', sortable: false, allowFilter: true },
					{
						text: this.$t('fields.shipType'),
						value: 'ship_type',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.startDate'),
						value: 'start_date',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.endDate'),
						value: 'end_date',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{
						text: this.$t('fields.durationMonths'),
						value: 'duration',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{ text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false },
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'id',
					descending: true,
				},
			},
			showModal: false,
			selectedNavigation: 0,
			totalDuration: 0,
		};
	},
	methods: {
		addClick() {
			this.showModal = true;
			this.selectedNavigation = 0;
		},
		closeModal() {
			this.showModal = false;
		},
		editClick(selectedNavigation) {
			this.selectedNavigation = selectedNavigation;
			this.showModal = true;
		},
		deleteClick(id) {
			let vm = this;
			this.$verify(this.$t('alerts.deletionQuestion'), (result) => {
				if (result) {
					vm.$APICall(
						'delete',
						'teacher-navigations/' + id + '/delete',
						{ teacher_id: this.$route.params.id, id: id },
						(data, success) => {
							if (success) {
								vm.$notify(vm.$t('alerts.basicDelete'));
								vm.reloadData(vm.teacherNavigationsTable.lastRequest);
							} else {
								vm.$alert(vm.$t('alerts.basicError'));
							}
						}
					);
				}
			});
		},
		selectHeaders(headers) {
			this.teacherNavigationsTable.selectedHeaders = headers;
		},
		reloadData(request) {
			this.teacherNavigationsTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'teacher-navigations/' + this.$route.params.id,
				request,
				(data, success) => {
					if (success) {
						vm.teacherNavigationsTable.items = data.items;
						vm.teacherNavigationsTable.total = data.total;
						vm.totalDuration = data.total_duration;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.teacherNavigationsTable.height = window.innerHeight - 330 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
